import React, { useEffect } from "react";

const getStateText = (reason) => {
    switch (reason) {
        case "ready":
            return "Способности готовы";
        case "cooldown":
            return "Способности восстанавливаются";
        case "battle_lock":
            return "Сейчас способности недоступны";
        case "disconnected":
            return "Связь с битвой потеряна";
        case "waiting":
            return "Ожидание начала битвы";
        default:
            return "Ожидание...";
    }
};

export const DeltaBattleScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#202020");
    }, []);

    const sendAbility = (ability) => {
        props.sendMessage(`sendtoserver|slov\\${ability}`);
    };

    return (
        <div id="game">
            <h1 id="slov_header">GUARDIANRUNE</h1>

            <div
                className="divtext_slov"
                style={{ color: "white", fontSize: "24px", marginBottom: "8px" }}
            >
                <b>{props.characterName}</b>
            </div>

            <div
                className="divtext_slov"
                style={{ color: "white", marginBottom: "22px" }}
            >
                {props.prName}
            </div>

            <button
                type="button"
                disabled={!props.attackEnabled}
                onClick={() => sendAbility(props.attackSignal)}
                style={{
                    width: "80%",
                    maxWidth: "340px",
                    minHeight: "72px",
                    marginBottom: "16px",
                    fontSize: "22px"
                }}
            >
                АТАКА
            </button>

            <br />

            <button
                type="button"
                disabled={!props.healEnabled}
                onClick={() => sendAbility(props.healSignal)}
                style={{
                    width: "80%",
                    maxWidth: "340px",
                    minHeight: "72px",
                    marginBottom: "24px",
                    fontSize: "22px"
                }}
            >
                ЛЕЧЕНИЕ
            </button>

            <div
                className="divtext_slov"
                style={{ color: "white", fontSize: "17px", marginBottom: "18px" }}
            >
                {getStateText(props.stateReason)}
            </div>

            <div
                className="divtext_slov"
                style={{
                    color: "white",
                    fontSize: "16px",
                    width: "84%",
                    maxWidth: "380px",
                    margin: "0 auto 12px auto"
                }}
            >
                <b>Атака:</b> {props.attackDescription}
            </div>

            <div
                className="divtext_slov"
                style={{
                    color: "white",
                    fontSize: "16px",
                    width: "84%",
                    maxWidth: "380px",
                    margin: "0 auto"
                }}
            >
                <b>Лечение:</b> {props.healDescription}
            </div>
        </div>
    );
};
